import { formatNumberAmount } from '@utils/utils.ts';

export const EMPTY_CELL_PLACEHOLDER = '–';

export const getAmountLabel = (amount: number, accountStatus) =>
	accountStatus === 'CLOSED' ? EMPTY_CELL_PLACEHOLDER : formatNumberAmount(amount);
